/** @jsxImportSource @gasman/smush */

import './bitmask.css';

import { Component } from '@gasman/smush';

class Bitmask extends Component {
    constructor(opts) {
        /*
        recognised opts:
        width
        property
        setter
        changeEvent
        vertical
        */
        super();
        this.width = opts.width || 32;
        this.property = opts.property;
        this.setter = opts.setter;
        this.changeEvent = opts.changeEvent;

        this.sample = null;
        this.undoBuffer = null;
        this.undoPath = null;

        this.cells = [];
        if (opts.vertical) {
            this.table = <table class="bitmask vertical"></table>;
            for (let x = 0; x < this.width; x++) {
                let row = <tr></tr>;
                this.table.appendChild(row);
                let cell = <td data-x={x}></td>;
                row.appendChild(cell);
                this.cells[x] = cell;
            }
        } else {
            let row = <tr></tr>;
            this.table = <table class="bitmask">{row}</table>;
            for (let x = 0; x < this.width; x++) {
                let cell = <td data-x={x}></td>;
                this.cells[x] = cell;
                row.appendChild(cell);
            }
        }

        this.mouseIsDown = false;
        this.newValue = null;
        this.activeCommand = null;
        this.table.addEventListener('mousedown', (event) => {
            // only trigger on left mouse button
            if (event.button != 0) return;

            this.mouseIsDown = true;
            var cell = event.target;
            if ('x' in cell.dataset) {
                var x = parseInt(cell.dataset.x);
                this.newValue = !this.sample[this.property][x];
                this.activeCommand = {
                    path: this.undoPath,
                    forward: {},
                    reverse: {},
                };
                if (this.undoBuffer) {
                    this.undoBuffer.push(this.activeCommand);
                }
                this.writeValue(x, this.newValue);
            } else {
                this.newValue = null;
            }
            return false;
        });
        this.table.addEventListener('mousemove', (event) => {
            if (this.mouseIsDown && this.newValue !== null) {
                var cell = event.target;
                if ('x' in cell.dataset) {
                    var x = parseInt(cell.dataset.x);
                    this.writeValue(x, this.newValue);
                }
            }
            return false;
        });
    }

    writeValue(x, newValue) {
        if (!(x in this.activeCommand.reverse)) {
            let oldValue = this.sample[this.property][x];
            this.activeCommand.reverse[x] = oldValue;
        }
        this.sample[this.setter](x, newValue);
        this.activeCommand.forward[x] = newValue;
    }

    render(container) {
        container.appendChild(this.table);
    }

    bind(sample, opts) {
        opts = opts || {};
        this.unbind();
        this.sample = sample;

        var arr = this.sample[this.property];
        for (var x = 0; x < this.width; x++) {
            this.renderValue(x, arr[x]);
        }

        if (opts.undoBuffer) {
            this.undoBuffer = opts.undoBuffer;
            this.undoPath = [...opts.undoPath, this.property];
        }

        this.sample.on(this.changeEvent, this.onChangeValue);
    }

    unbind() {
        if (this.sample) {
            this.sample.removeListener(this.changeEvent, this.onChangeValue);
            this.sample = null;
            this.undoBuffer = null;
            this.undoPath = null;
        }
    }

    show() {
        document.body.addEventListener('mouseup', this.onMouseUp);
    }

    hide() {
        document.body.removeEventListener('mouseup', this.onMouseUp);
    }

    onMouseUp = (event) => {
        // only trigger on left mouse button
        if (event.button != 0) return;

        this.mouseIsDown = false;
        this.activeCommand = null;
    };

    onChangeValue = (t, val) => {
        this.renderValue(t, val);
    };

    renderValue(t, val) {
        this.cells[t].innerText = val ? '1' : '0';
    }

    static forField(field, opts) {
        return new Bitmask({
            width: field.length,
            property: field.name,
            setter: field.setterName,
            changeEvent: field.eventName,
            ...opts,
        });
    }
}

export { Bitmask };
